<template>
  <div>
    <div v-if="narrowLayout">
      <span id="signatures-size" class="inlined-progress-text" data-signatures-size="petition.cached_signatures_size">
        <!-- Asterisk intentionally inlined to avoid extra whitespace -->
        {{ i18n.toNumber(progress.currentSignaturesCount, {precision: 0}) }}<template v-if="showUnconfirmedSignaturesDisclaimer">*</template>
      </span>
      <span class="inlined-progress-text">
        {{ i18n.t('public.petitions.sign.of_goal_signatures_without_breakline_html', { goal: i18n.toNumber(progress.currentSignaturesGoal, {precision: 0}) }) }}
      </span>
    </div>

    <div v-else class="stat-block stat-block-major">
      <div class="stat-number">
        <span id="signatures-size" data-signatures-size="petition.cached_signatures_size">
          <!-- Asterisk intentionally inlined to avoid extra whitespace -->
          {{ i18n.toNumber(progress.currentSignaturesCount, {precision: 0}) }}<template v-if="showUnconfirmedSignaturesDisclaimer">*</template>
        </span>
      </div>
      <div class="stat-label">
        <span v-html="signaturesLabelWithBreakline" />
      </div>
    </div>

    <animated-progress-bar :percentage-done="progress.progressPercentage"
                           :class="[{'taller-progress-bar': narrowLayout}, 'mb-3']" />
  </div>
</template>

<script>
import AnimatedProgressBar from '@/components/animated-progress-bar'
import { mapState } from 'vuex'

export default {
  components: { AnimatedProgressBar },

  props: {
    narrowLayout: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapState(['progress', 'showUnconfirmedSignaturesDisclaimer']),

    signaturesLabelWithBreakline() {
      return this.i18n.t('public.petitions.sign.of_goal_signatures_with_breakline_html', { goal: this.i18n.toNumber(this.progress.currentSignaturesGoal, {precision: 0}) })
    }
  }
}
</script>

<style lang="scss" scoped>
.inlined-progress-text {
  font-weight: bold;
}

::v-deep(.taller-progress-bar) {
  height: 30px;
}
</style>
